import { LanguageKey } from "../_utils";

export interface ChangLanguageRequest {
  type: string;
  value: LanguageKey;
}
